import { render, staticRenderFns } from "./SubMessageAlert.vue?vue&type=template&id=866ee644&scoped=true&lang=pug"
import script from "./SubMessageAlert.vue?vue&type=script&lang=ts"
export * from "./SubMessageAlert.vue?vue&type=script&lang=ts"
import style0 from "./SubMessageAlert.vue?vue&type=style&index=0&id=866ee644&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "866ee644",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('866ee644')) {
      api.createRecord('866ee644', component.options)
    } else {
      api.reload('866ee644', component.options)
    }
    module.hot.accept("./SubMessageAlert.vue?vue&type=template&id=866ee644&scoped=true&lang=pug", function () {
      api.rerender('866ee644', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Alert/CustomAlert/SubMessageAlert.vue"
export default component.exports